var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
export function formatPrice(value, currency = 'USD', locale = 'en-US', format = 'currency', removeCents = false) {
    const formatter = new Intl.NumberFormat(locale, {
        style: format,
        currency,
        minimumFractionDigits: removeCents ? 0 : 2,
    });
    if (isNaN(Number(value))) {
        return '';
    }
    return formatter.format(Number(value));
}
export const Price = (_a) => {
    var { className, children, values = [], size, variant = 'primary', currency = 'USD', locale = 'en-US', format = 'currency', info = '', weight, removeCents = false, isRange = false } = _a, other = __rest(_a, ["className", "children", "values", "size", "variant", "currency", "locale", "format", "info", "weight", "removeCents", "isRange"]);
    const componentClassName = classnames('sparky-c-price', className, {
        'sparky-c-price--sm': size === 'sm',
        'sparky-c-price--lg': size === 'lg',
        'sparky-c-price--xl': size === 'xl',
        'sparky-c-price--disabled': variant === 'disabled',
        'sparky-c-price--sale': variant === 'sale',
        'sparky-c-price--light': weight === 'light',
        'sparky-c-price--light-sale': variant === 'light-sale',
    });
    if (variant === 'disabled') {
        const componentClassName = classnames('sparky-c-price', 'sparky-c-price__strike-group', className, {
            'sparky-c-price--sm': size === 'sm',
            'sparky-c-price--lg': size === 'lg',
            'sparky-c-price--xl': size === 'xl',
            'sparky-c-price--range': isRange === true,
        });
        const salePriceLow = formatPrice(values[0], currency, locale, format, removeCents);
        const salePriceHigh = formatPrice(values[1], currency, locale, format, removeCents);
        if (isRange && values.length === 4) {
            return (_jsxs("div", Object.assign({ className: componentClassName }, { children: [_jsx("div", Object.assign({ className: "sparky-c-price--data" }, { children: _jsx("div", Object.assign({ className: "sparky-c-price--sale", "aria-label": `sale price from ${salePriceLow} to ${salePriceHigh}` }, { children: `${salePriceLow} - ${salePriceHigh}` })) })), info && _jsx("div", Object.assign({ className: "sparky-c-price--meta" }, { children: info }))] })));
        }
        return (_jsxs("div", Object.assign({ className: componentClassName }, { children: [_jsxs("div", Object.assign({ className: "sparky-c-price--data", "aria-label": `sale price ${salePriceLow} original price ${salePriceHigh}` }, { children: [_jsx("div", Object.assign({ className: "sparky-c-price--sale" }, { children: salePriceLow })), _jsx("div", Object.assign({ className: "sparky-c-price--disabled" }, { children: salePriceHigh }))] })), info && _jsx("div", Object.assign({ className: "sparky-c-price--meta" }, { children: info }))] })));
    }
    const priceRange = values.reduce((acc, cur, idx) => {
        return idx === 0
            ? formatPrice(cur, currency, locale, format, removeCents)
            : `${acc} - ${formatPrice(cur, currency, locale, format, removeCents)}`;
    }, '');
    function getAriaLabel() {
        if (values.length > 0) {
            return variant === 'sale'
                ? `sale price range is ${priceRange}`
                : `price range is ${priceRange}`;
        }
        return variant === 'sale'
            ? `sale price is ${priceRange}`
            : `price is ${priceRange}`;
    }
    return (_jsxs("div", Object.assign({ className: componentClassName }, other, { "aria-label": getAriaLabel().replace('-', 'to') }, { children: [priceRange, info && _jsx("div", Object.assign({ className: "sparky-c-price--meta" }, { children: info })), children] })));
};
//# sourceMappingURL=Price.js.map